// Venta cruzada de accesorios: añade al carrito en un clic sin salir de la página.
// En la ficha y en el carrito lateral actualiza el carrito lateral; en la página del carrito recarga.
if (!customElements.get('cp-upsell')) {
  customElements.define(
    'cp-upsell',
    class CpUpsell extends HTMLElement {
      connectedCallback() {
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      async onClick(event) {
        const button = event.target.closest('[data-cp-add]');
        if (!button || button.disabled) return;

        const error = this.querySelector('.cp-upsell__error');
        if (error) error.hidden = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.classList.add('is-loading');

        const cart = document.querySelector('cart-drawer');
        const useDrawer = this.dataset.context !== 'cart-page' && cart && typeof cart.renderContents === 'function';
        const body = { items: [{ id: Number(button.dataset.variantId), quantity: 1 }] };
        if (useDrawer) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        try {
          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || '');

          button.classList.remove('is-loading');
          button.classList.add('is-done');

          if (useDrawer && data.sections) {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.setActiveElement && cart.setActiveElement(button);
            cart.renderContents(data);
          } else {
            window.location.reload();
          }
        } catch (e) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.classList.remove('is-loading');
          if (error) {
            error.textContent = e.message || 'No se ha podido añadir. Inténtalo de nuevo.';
            error.hidden = false;
          }
        }
      }
    }
  );
}
